<template>
  <div class="page protocol">
    <navigation>征信查询授权书</navigation>
            
    <section class="content">
      <p><strong>深圳市飞贷小额贷款有限公司：</strong></p>
      <p class="text tab-2">鉴于本人姓名：<span class="underline">●</span>，身份证号码：<span class="underline">●</span>，同意本人订立的编号为<span class="underline">●</span>的《“飞贷”额度借款合同》（包括《“飞贷”额度借款合同》条款及其组成部分）的内容，向贵司与贵司推荐的其他贷款人申请借款。本人同意并不可撤销地授权贵司和贷款人（以本人签署的《借款合同》载明的贷款人为准，包括<strong>南京银行、潍坊银行、中国对外经济贸易信托有限公司、云南国际信托有限公司</strong>等）按照《征信业管理条例》以及人民银行关于征信基础数据库系统的相关规定行使下列权限：
      </p>
      <p class="text tab-2">1、向金融信用信息基础数据库及其他依法成立的征信机构采集、查询、打印、保存本人的信用信息。</p>
      <p class="text tab-2">2、将本人的个人信用信息用于评价本人的信用状况、授信额度项下借款前审核及进行贷后风险管理。</p>
      <p class="text tab-2">3、贵司有权决定，本人履行《“飞贷”额度借款合同》产生的信用信息（包括逐笔贷款逾期信息）由贵司或由贷款人向金融信用信息基础数据库及其他依法成立的征信机构提供。如贵司因本人贷款逾期而根据《“飞贷”额度借款合同》实施代偿或向贷款人购买逾期债权，贵司有权提供本人的贷款逾期信息。
      </p>
      <p class="text tab-2">4、若本人业务未获批准办理，本授权书及本人信用报告等资料无须退回本人。</p>
      <p class="text tab-2">5、本人同意并不可撤销地授权贵司为核实本人身份、评价本人信用或进行贷后管理的目的，以合法的方式自行或通过第三方机构收集、核实本人的信息（包括但不限于本人的个人身份证信息等），并对获得的信息进行合法的使用和留存等操作。</p>
      <p class="text tab-2">如果贵司超出本授权书范围进行数据报送和查询使用，应当事先取得本人的同意，否则贵司应承担与此有关的法律责任。</p>
      <p class="text tab-2">本授权自本人以数据电文形式在本授权书上签名之时即视为授权生效，一旦生效后不可撤销，至本人《“飞贷”额度借款合同》项下的授信额度到期之日止失效。</p>
      <p class="text tab-2"><strong>本人声明：本人已仔细阅读上述所有条款。贵司已应本人要求对相关条款予以明确说明。本人对所有条款的含义及相应的法律后果已全部通晓并充分理解，本人自愿作出上述授权、承诺和声明</strong></p>
      <p class="text tab-2 margin-top-40">授权人：●</p>
      <p class="text tab-2 margin-top-20">日期：●</p>
      <p class="text tab-2 margin-top-20">本人已充分阅读并理解上述文件，愿意接受上述文件的约束。</p>
      <p class="text tab-2 margin-top-40">签字人： ●</p>
      <p class="text tab-2 margin-top-20">日期：●</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'fd-authorization'
}
</script>
